import { ReactNode } from 'react';
import { SectionHeader } from '../../partner-pages/utils/section-header';
import { CardsSecure } from './cards_secure';

interface SecureProps {
  data: {
    hero: {
      heading: string;
      headingclass?: string;
      h2Heading?: boolean;
      subHeading?: string;
      imageSource?: string;
      videoSource?: string;
      btnText?: string;
      btnLink?: string;
      bulletPoint?: string[];
      description?: string;
      companyLogo?: string;
      children?: ReactNode;
      mediaHeight?: number;
      mediaWidth?: number;
    };
    cards: {
      icon: string;
      heading: string;
      description: string;
    }[];
  };
}

const SecureComponent = ({ data }: SecureProps): JSX.Element => {
  const { hero, cards } = data;
  return (
    <div className="pt-28 sm:pt-14">
      <div className="flex justify-between pb-3">
        <div className="w-1/2 sm:w-full">
          <SectionHeader
            align={'left'}
            heading={hero.heading}
            description={hero.description}
          />
        </div>
        <img
          src={hero.imageSource}
          alt="image"
          width={hero.mediaWidth}
          height={hero.mediaHeight}
          className="sm:hidden"
        />
      </div>
      <div className="flex flex-wrap pt-12 sm:pt-1">
        {cards.map((item) => (
          <div className="w-1/3 -mt-5 sm:w-full sm:mt-2" key={item.heading}>
            <CardsSecure cardData={item} />
          </div>
        ))}
      </div>
    </div>
  );
};

export { SecureComponent };
